import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      isAndroidApp: false
    };

    super('shared', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {}
}

export default Store;
